module.exports = __webpack_public_path__ + "static/media/home.56282669.svg";